import { useCurrenciesContext } from '../contexts/CurrenciesContext';
import type { Currency } from '../types/Currency';

export const useCurrency = (symbol: string | null | undefined): Currency | undefined => {
  const { currenciesBySymbol } = useCurrenciesContext();
  if (symbol != null) {
    return currenciesBySymbol.get(symbol);
  }
};
